import { safeDateFormat } from "../utils";

import { TEXT } from "Clients/ACCB/ACCBTheme";
// Mirrors the backend's _is_bac_privileged(): these roles adjourn directly
// (status "direct") and can action a party's pending request.
export const PRIVILEGED_TYPES = [
	"arbitrator_rv",
	"sub_admin_tiac_rv",
	"case_manager",
];

export const STATUS_STYLES = {
	pending: { label: "Pending", bg: "#FDF2CF", color: TEXT.warning },
	approved: { label: "Approved", bg: "#E4F5EA", color: TEXT.success },
	rejected: { label: "Rejected", bg: "#FDE7E7", color: TEXT.error },
	direct: { label: "Direct", bg: "#E6F0FD", color: TEXT.info },
};

// Order used by the status filter on the Previous Requests screen.
export const STATUS_OPTIONS = ["approved", "rejected", "direct", "pending"];

export const statusStyle = (status) =>
	STATUS_STYLES[status] || { label: status || "—", bg: "#EEEEEE", color: TEXT.primary };

export const formatApiDate = (d) => {
	if (!d) return "";
	if (typeof d === "string") {
		if (/^\d{4}-\d{2}-\d{2}$/.test(d.trim())) return d.trim();
		const parsed = new Date(d);
		if (!isNaN(parsed.getTime())) {
			return safeDateFormat(parsed, "yyyy-MM-dd");
		}
		return "";
	}
	if (d instanceof Date && !isNaN(d.getTime())) {
		return safeDateFormat(d, "yyyy-MM-dd");
	}
	return "";
};

// Party short codes for the case: claimants become C1/C2/C3… and respondents
// R1/R2/R3… in the order they appear on the case. Everyone else (Arbitrator,
// Claimant's Counsel, …) keeps their profile type as the label.
export const buildPartyLabels = (allProfiles) => {
	const labels = {};
	let claimants = 0;
	let respondents = 0;
	(allProfiles || []).forEach((p) => {
		const id = p?.profile?.id;
		if (id === undefined || id === null) return;
		const type = p?.profile?.profile_type || "";
		if (type === "Claimant") {
			claimants += 1;
			labels[String(id)] = `C${claimants}`;
		} else if (type === "Respondent") {
			respondents += 1;
			labels[String(id)] = `R${respondents}`;
		} else {
			labels[String(id)] = type;
		}
	});
	return labels;
};

// { role, name } for whoever raised the request. role is "" when the requester
// is not a case participant (e.g. registry staff acting on the case).
export const requesterInfo = (adj, partyLabels) => ({
	role: (partyLabels || {})[String(adj?.requested_by)] || "",
	name: adj?.requested_by_name || "—",
});

// The date the hearing actually moves to. Only a granted adjournment (raised
// directly by the tribunal/registry, or approved by them) moves the hearing —
// a pending request merely proposes one and a rejected one changes nothing.
export const nextHearingText = (adj) => {
	if (!adj) return "—";
	if (adj.status === "approved" || adj.status === "direct") {
		return adj.proposed_date ? safeDateFormat(adj.proposed_date) : "Not recorded";
	}
	if (adj.status === "rejected") return "Unchanged";
	return adj.proposed_date
		? `${safeDateFormat(adj.proposed_date)} (proposed)`
		: "Not proposed";
};
